import { 
  FaFacebookF, 
  FaYoutube, 
  FaTiktok, 
  FaTwitter, 
  FaInstagram, 
  FaWhatsapp,
  FaGlobe, 
  FaLinkedinIn 
} from 'react-icons/fa';

export const socialConfig = {
  'ফেসবুক পেজ': {
    icon: FaFacebookF,
    color: '#1877F2',
    name: 'ফেসবুক'
  },
  'ইউটিউব চ্যানেল': {
    icon: FaYoutube,
    color: '#FF0000',
    name: 'ইউটিউব'
  },
  'টিকটক': {
    icon: FaTiktok,
    color: '#000000',
    name: 'টিকটক'
  },
  'টুইটার': {
    icon: FaTwitter,
    color: '#1DA1F2',
    name: 'টুইটার'
  },
  'ইনস্টাগ্রাম': {
    icon: FaInstagram,
    color: '#E4405F',
    name: 'ইনস্টাগ্রাম'
  },
    'হোয়াটসঅ্যাপ': {
    icon: FaWhatsapp,
    color: '#25D366',
    name: 'হোয়াটসঅ্যাপ'
  },
  'লিংকডইন': {
    icon: FaLinkedinIn,
    color: '#0A66C2',
    name: 'লিংকডইন'
  },
  'অন্যান্য': {
    icon: FaGlobe,
    color: '#666666',
    name: 'ওয়েবসাইট'
  }
};